module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4gsTFgk5NEg1ygAAAPhJREFUaN7t2LFpQzEURmGDCZg4+FVewRN4AYP3SOGUxjsEsoNrj5ABnC6LBDKCq8C5aVSoeRJxnqQr+E99BfrgqtFsppRSSimlVMvM7Al4Ay7AtksEsAI+LQTczGzfNaJLzBiiK0wO0QUmsU5X4AjgHpNCmNljmDm4xpjZkENEYJ+YvyDcYu5BuMMkEB85hBvMFIjmmCkRzTAlENUxJRHVMDUQxTE1EcUwLRCTY1oiJsN4QPwbAyy9IHIYYJc69OoJkcF8pw6cvSGiu73EmLBi87HhDfAVBt+9IKL7PYe1+gFOucf+AKwd/5UtzGzQr6FSSimlVL1+AYa3m3ULdWL3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-arrowup.png
// module id = 654
// module chunks = 0